'use client';

import { Toaster } from 'sonner';
import { zIndex } from '@/shared/ui/z-index';
import styles from './ProductCommandToaster.module.css';

/** CCTV 명령 결과를 녹음 방송 알림과 같은 스타일로 오른쪽 아래에 표시합니다. */
export function ProductCommandToaster() {
  return (
    <Toaster
      id="cctv-commands"
      position="bottom-right"
      visibleToasts={3}
      closeButton
      className={styles.toaster}
      offset={{ right: 24, bottom: 'calc(24px + var(--app-safe-bottom-offset, 0px))' }}
      mobileOffset={{ right: 16, bottom: 'calc(16px + var(--app-safe-bottom-offset, 0px))' }}
      style={{ zIndex: zIndex.realtimeNotification, width: 'min(500px, calc(100vw - 32px))', left: 'auto' }}
      toastOptions={{
        unstyled: true,
        closeButtonAriaLabel: '명령 상태 알림 닫기',
        classNames: {
          toast: styles.toast,
          content: styles.content,
          title: styles.title,
          description: styles.description,
          closeButton: styles.close,
          actionButton: styles.action,
        },
      }}
    />
  );
}
